import type { LogsEvent } from "@datadog/browser-logs";

const EMAIL = /[^\s/"'?&=#:,;<>()]+(?:@|%40)[^\s/"'?&=#:,;<>()]+\.[a-z]{2,}/gi;
// Stops before ":line:col" so that stack frames keep their source position.
const QUERY_OR_FRAGMENT = /[?#][\w%.-]+=[^\s"'`)]*?(?=:\d+:\d+|[\s"'`)]|$)/g;

const maskEmails = (text: string) => text.replace(EMAIL, "[email]");

export const scrubText = (text: string) =>
  maskEmails(text.replace(QUERY_OR_FRAGMENT, ""));

export const scrubUrl = (url: string) => {
  const [, path = "", query = ""] = url.match(/^([^?#]*)\??([^#]*)/) ?? [];

  const utmParams = Array.from(new URLSearchParams(query)).filter(([key]) =>
    key.startsWith("utm_"),
  );
  const utmQuery = new URLSearchParams(utmParams).toString();

  return maskEmails(utmQuery ? `${path}?${utmQuery}` : path);
};

export const scrubLog = (log: LogsEvent) => {
  log.message = scrubText(log.message);
  log.view.url = scrubUrl(log.view.url);

  if (log.view.referrer) {
    log.view.referrer = scrubUrl(log.view.referrer);
  }

  if (log.http) {
    log.http.url = scrubUrl(log.http.url);
  }

  if (log.error?.message) {
    log.error.message = scrubText(log.error.message);
  }

  if (log.error?.stack) {
    log.error.stack = scrubText(log.error.stack);
  }

  if (typeof log.path === "string") {
    log.path = scrubText(log.path);
  }
};
